module.exports = __webpack_public_path__ + "img/portrait-015.9a2ef2e5.jpg";